/**
 * AUTH-002 — where the browser Supabase client finds the tab's session controller.
 *
 * Deliberately import-free: `src/lib/supabase/client.tsx` reads the controller through
 * this module, and `runtime.ts` (which imports the client) registers it here, so there is
 * no import cycle at module load.
 */
import type { SessionController } from './session-controller';

let current: SessionController | null = null;

export function setActiveController(c: SessionController | null): void {
  current = c;
}

export function getActiveController(): SessionController | null {
  return current;
}
